import * as Sentry from "@sentry/browser";

window.Sentry = Sentry;
window.sentryIntegrations = [Sentry.browserTracingIntegration()];
